<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">未来で働く人々に聞いた、2021年のスタートアップトレンド予測</h1>
                <span class="meta"> Posted in April 2021 </span>

                <p class="author-info ">Mark Bivens is a Silicon Valley native and former entrepreneur, having started three companies before becoming a VC. He is the Managing Partner of Shizen Capital (formerly known as Tachi.ai Ventures) in Japan. You can read more on his blog at <a href="http://markbivens.com">http://rude.vc</a> or follow him on Twitter <a href="https://twitter.com/markbivens">@markbivens</a>.</p>

                <figure>
                  <img class="img-fluid" src="img/blog/card/2021techtrends.png" alt="">
                </figure>
                
                <p>新しい年が明けると、しばしば私は未来を想像するのが好きなので、技術革新の新しいトレンドを予測することに生計を立てている人、典型的には起業家や仲間のVCにアドバイスを求めることが多い。</p>

                <p>もちろん、2020年は他の年に比べて過激な異例の年であることが証明されているので（そして、2020年がついに終わりを迎えたと感じていられるのも、1月の最終週である今週までだ）、私が既に未来で働く人々から直接知恵を求めるのは今こそ適切だと思った。日本での最初のファンドを成功させることができたのは、以下の方々のおかげだ。彼らの言葉は福音だ。</p>

                <p>（訳注：本稿はこれから生じることについて、未来視点から過去を振り返る形で書かれているものがあります。それらについては、日本語訳も過去形で表現しています。）</p>


                <h3 class="section-heading">Jay Winder 氏（MakeLeaps 創業者。2018年にリコーが買収。）</h3>
                
                <div>
                  <img v-lazy="'img/team-photos/jaywinder.png'" class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                  <p>私は常に、未来の世代が我々のことをどう見るかに興味を持っている。だから、私の予測は、将来、我々がどう見られるかに基づいている。我々の子孫は、直前の10年を振り返って見ることになるだろう。</p>
                </div>

                <p>ほとんどが共有されていた現実の経験が、すべてのニュースフィードに組み込まれた「確証バイアス・アズ・ア・サービス」アルゴリズムによって、何億もの個別の現実へと分裂していくのだ。</p>

                <p>かつて中央集権的な情報源や権威への信頼が存在していた穴で、いくつかの新しい宗教が誕生した。</p>

                <p>前述した点に関連して、デジタル希少性の革新の上に築かれた主権を持つインターネットネイティブの貨幣システムという、人類史上最も重要な発明の一つが誕生した。</p>

                <h3 class="section-heading">Stephen Leguillon 氏（フランスのオンラインプライベートシェフ予約プラットフォーム「La Belle Assiette」およびケータリングプラットフォーム「GoCater」創業者。前者は Elior、後者は EZCater が買収。）</h3>
                
                <div>
                  <img v-lazy="'img/team-photos/stephenleguillon.png'" class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                  <p>生産性 SaaS、マーケットプレイス、消費者向けビジネスは、フィンテックやインシュアテックのインフラ企業を利用して収益を増やすことになるだろう。例えば、マーケットプレイスは、Swan や Stripe Capital のような Banking as a Service（BaaS）のユーティリティをプラットフォームに利用し、マーケットプレイス上のサプライヤーのために銀行口座を開設したり、デットファイナンスを行ったりするだろう。あるいは、EC プラットフォームは、Seyna のような Insuarance as a Service の ユーティリティを使用して、製品の保証を販売することになるだろう。2021年には、このようなマネタイズ戦略がトレンドになるだろう。</p>
                </div>

                <p>Shopify の2020年の成功と新型コロナウイルス感染拡大が促したデジタル化の必要性から、ブランドや独立系小売業者は、アグリゲーターマーケットプレイスからの独立を加速させるだろう。ブランドや独立系小売業者は、DTC マーケティングと流通を倍増させていくだろう。これは、このトレンドを可能にする SaaS やインフラ企業に巨大な成長機会をもたらすだろう。</p>

                <p>2021年の技術とビジネスの議論は、GAFA の独占とそのアンバンドリングに集中するだろう。実際の結論や行動は2021年には出てこないと思う。</p>

                <h3 class="section-heading">Warren Hayashi 氏（オランダ発のグローバル決済企業 Adyen 創業者。2018年にIPO。）</h3>
                
                <div>
                  <img v-lazy="'img/team-photos/warrenhayashi.png'" class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                  <p>分割払いは日常的な支払方法になるだろう。利便性の向上と家計の逼迫という双子の力によって、分割払いの選択肢が主流となり、この傾向は2021年には拡大すると予想されている。機械学習アルゴリズムは、これまで以上に瞬時にリスクを評価できるようになり、レジで「今買って後払い（buy now, pay later）」オプションを簡単に提供できるようになっている。小額商品や中額商品の場合、買い物客は今100ドルを支払う代わりに、毎月25ドルを4ヶ月間支払うことを知るようになる。このような透明性があることで、買い物を躊躇している買い物客も簡単に購入に踏み切ることができ、最悪のショッピングカート放棄を回避したいと考えている加盟店にとっては魅力的だ。</p>
                </div>

                <p>2021年には、「今買って後払い」オプションを提供するプロバイダは、高額な複数年契約に焦点を当てているところもあれば、50ドル程度のショッピングバスケットの分割払いプランを提供しようとしているところもあるため、それ自体が分かれ始めるだろう。ストリーミングサービスからフードデリバリープレミアムメンバーシップまで、あらゆるものを月ごとに支払うことに慣れてきた世帯の目には、分割払いプランは、たまたま終了日が決まっているだけのサブスクリプションのように見え始めている。</p>


                <h3 class="section-heading">Marty Roberts 氏（医薬情報担当者（MR）支援「エンタッチ」創業者。2020年に東邦薬品が買収。）</h3>
                
                <div>
                  <img v-lazy="'img/team-photos/martyroberts.png'" class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                  <p>私の直感では 2021年は反幕末的な予感がしている。我々は平常心と平穏に戻る。そして、我々はそれについて奇妙に感じるだろう。私が正確に予測できることは、あなた（Bivens 氏）のファンドのための別の魅力的な投資機会に関与しているということだ。</p>
                </div>

                <div class="add__highlight">関連記事</div>
                <p><a href="https://thebridge.jp/2018/04/american-got-japanese-government-fund-startup-entouch">•	日本の非効率な医療現場を変えるエンタッチ、あるアメリカ人起業家の挑戦【ゲスト寄稿】</a></p>

                <p>アーメン、マーティ。新しい年が穏やかで健康であることを祈っています。 </p>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.add__highlight {
  color: white;
  font-size: 20px;
  font-weight: 700;
}

.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 64px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
